export const getHighestPrescriptionType = (types: string[]): string | null => {
  const priority = ['CHECK', 'HELD', 'SIMPLE', 'NOT_REQUIRED', null];

  return types.reduce((highest, current) => {
    if (
      highest === undefined ||
      priority.indexOf(current) < priority.indexOf(highest)
    ) {
      return current;
    }
    return highest;
  }, undefined as string | undefined);
};
